<template>
    <div class="module container-fluid">
        <ModuleTitle :caption="item.title" :text="item.desc"></ModuleTitle>
        <!--<img v-if="item.banner.isPic"-->
             <!--:src="item.banner.imgSrc">-->

        <!--<CustomVideo v-if="item.banner.isVideo"-->
                     <!--:video="item.banner.video">-->
        <!--</CustomVideo>-->
    </div>
</template>

<script>
    import ModuleTitle from '../../common/ModuleTitle'
    //import CustomVideo from '../../common/CustomVideo'

    export default {
        name:'storyAbstract',
        props: {
            item: Object,
        },
        components: {
            ModuleTitle,
            //CustomVideo,
        }
    }
</script>

<style lang="less" scoped>
    .module /deep/ .module-sub-title {
        margin-left: auto;
        margin-right: auto;
        max-width: 1000px;
    }

    img {
        width: 100%;
    }
</style>
